import { __rest, __assign } from '../node_modules/tslib/tslib.es6.mjs.js';
import React from 'react';
import { Modal as Modal$1, AlertDialogOverlay, ModalContent, ModalHeader, Box, ModalCloseButton, Divider, ModalBody, ModalFooter, Flex, Button } from '@chakra-ui/react';
import CaretLeft from '../icons/CaretLeft.js';

var Modal = function (_a) {
    var title = _a.title, _b = _a.cancelButtonText, cancelButtonText = _b === void 0 ? "Cancel" : _b, _c = _a.okButtonText, okButtonText = _c === void 0 ? "Confirm" : _c, footer = _a.footer, children = _a.children, hideFooter = _a.hideFooter, hideCloseButton = _a.hideCloseButton, modalHeader = _a.modalHeader, okButtonOnClick = _a.okButtonOnClick, cancelButtonOnClick = _a.cancelButtonOnClick, _d = _a.isDividerVisible, isDividerVisible = _d === void 0 ? false : _d, onBackButtonClick = _a.onBackButtonClick, _e = _a.isBackButtonVisible, isBackButtonVisible = _e === void 0 ? false : _e, _f = _a.styles, styles = _f === void 0 ? {} : _f, _g = _a.direction, direction = _g === void 0 ? "ltr" : _g, args = __rest(_a, ["title", "cancelButtonText", "okButtonText", "footer", "children", "hideFooter", "hideCloseButton", "modalHeader", "okButtonOnClick", "cancelButtonOnClick", "isDividerVisible", "onBackButtonClick", "isBackButtonVisible", "styles", "direction"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal$1, __assign({}, args),
            React.createElement(AlertDialogOverlay, null),
            React.createElement(ModalContent, { boxShadow: "shadow-high", sx: __assign({}, styles.content) },
                modalHeader && (React.createElement(ModalHeader, { sx: __assign({}, (direction === "rtl" && {
                        textAlign: "right",
                        paddingRight: "24px",
                        display: "flex",
                        justifyContent: "flex-start",
                    })) }, modalHeader)),
                title && (React.createElement(ModalHeader, { display: "flex", alignItems: "center", gap: 3, sx: __assign({}, (direction === "rtl" && {
                        justifyContent: "flex-start",
                        paddingRight: "24px",
                    })) },
                    isBackButtonVisible && (React.createElement(Box, { onClick: onBackButtonClick, cursor: "pointer" },
                        React.createElement(CaretLeft, null))),
                    title)),
                !hideCloseButton && React.createElement(ModalCloseButton, { sx: __assign({}, (direction === "rtl" && {
                        left: "12px",
                        right: "auto",
                    })) }),
                isDividerVisible && React.createElement(Divider, { color: "#E4E8EE" }),
                React.createElement(ModalBody, { sx: __assign({}, styles.body) }, children),
                isDividerVisible && React.createElement(Divider, { color: "#E4E8EE" }),
                !hideFooter && (React.createElement(ModalFooter, null, footer ? (footer) : (React.createElement(Flex, { sx: __assign({}, (direction === "rtl" && {
                        gap: "8px",
                        paddingLeft: "24px",
                    })) },
                    cancelButtonOnClick ? (React.createElement(Button, { colorScheme: "black", variant: "secondary", mr: 2, onClick: cancelButtonOnClick },
                        " ",
                        cancelButtonText,
                        " ")) : null,
                    okButtonOnClick ? (React.createElement(Button, { onClick: okButtonOnClick },
                        " ",
                        okButtonText,
                        " ")) : null))))))));
};

export { Modal as default };
//# sourceMappingURL=Modal.js.map
